import { render, staticRenderFns } from "./muokkaa-koulutusjaksoa.vue?vue&type=template&id=00e0defb&scoped=true&"
import script from "./muokkaa-koulutusjaksoa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-koulutusjaksoa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-koulutusjaksoa.vue?vue&type=style&index=0&id=00e0defb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e0defb",
  null
  
)

export default component.exports